import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Remote.css";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Remote = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
    devices,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });
    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (button) => {
    // Get button Info
    // setIsLoading(true);
    if (scenarioCommandDetail.id) {
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: 5,
                data2: button.data1,
                data3: button.data2,
                data4: button.data3,
                data5: button.data4,
                data6: button.data5,
                data7: null,
                data8: null,
                data9: null,
                data10: null,
                data11: null,
                command_name: String(button.name),
                icon: button.icon ?? 20,
              }
            : command
        )
      );
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // UpdateScenarioCommand({
      //   scenario_command_id: scenarioCommandDetail.id,
      //   device_id: button.device_id,
      //   time: scenarioCommandDetail.time,
      //   data1: 5,
      //   data2: button.data1,
      //   data3: button.data2,
      //   data4: button.data3,
      //   data5: button.data4,
      //   data6: button.data5,
      //   command_name: button.name,
      //   icon: button.icon,
      // }).then(({ data: data1 }) => {
      //   SuccessToast("دستور با موفقیت جایگزین شد");
      //   const newScenarioCommands = scenarioCommands.map((scn) => {
      //     if (scn.id === scenarioCommandDetail.id) {
      //       return {
      //         ...scn,
      //         device_id: button.device_id,
      //         time: scenarioCommandDetail.time,
      //         data1: 5,
      //         data2: button.data1,
      //         data3: button.data2,
      //         data4: button.data3,
      //         data5: button.data4,
      //         data6: button.data5,
      //         command_name: button.name,
      //         icon: button.icon,
      //       };
      //     }
      //     return scn;
      //   });
      //   setScenarioCommands(newScenarioCommands);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    } else {
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: 5,
          data2: button.data1,
          data3: button.data2,
          data4: button.data3,
          data5: button.data4,
          data6: button.data5,
          data7: null,
          data8: null,
          data9: null,
          data10: null,
          data11: null,
          icon: button.icon ?? 20,
          command_name: String(button.name),
          device_id: button.device_id,
          time: 500,
        },
      ]);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // setIsLoading(true);
      // CreateScenarioCommand({
      //   scenario_id: addScenarioCommandDetail.scenario_id,
      //   data1: 5,
      //   data2: button.data1,
      //   data3: button.data2,
      //   data4: button.data3,
      //   data5: button.data4,
      //   data6: button.data5,
      //   icon: button.icon,
      //   command_name: button.name,
      //   device_id: button.device_id,
      //   time: 500,
      // }).then(({ data }) => {
      //   SuccessToast("دستور با موفقیت اضافه گردید");
      //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    }
  };
  const renderButtons = () => {
    return buttons.map((button) => {
      let iconPath = "/assets/img/app-icons/CU.png";
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon
        );
        iconPath = buttonIcon.path;
      }
      return (
        <div className="remote" onClick={() => handleClickButton(button)}>
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div className="status-part"></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0" style={{fontSize: '11px'}}>
              S/{devices.find((d) => d.id == button.device_id)?.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
          <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Remote);
